import React, { useState } from 'react';
import * as PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';
import { Fieldset, BoutonRadio, Container } from '@design-system-etat/dsfr-react';
import { useForm } from 'react-hook-form';
import { useSelector } from 'react-redux';
import BoutonEtape from 'components/form/boutonsEtape/BoutonEtape';
import RoutesRatelier from '../../../../ratelier/routes';
import { getPath } from '../../../../../../utils/router';

const SignalerErreurEtape1 = ({ etapeSuivante, resetSignalerArmeData, signalerArmeData }) => {
    const { isLoading } = useSelector((state) => state.armes.signalerErreur.recuperer);

    const { handleSubmit, register, watch, setValue } = useForm({
        mode: 'onChange',
    });
    const history = useHistory();
    const [disabledButton, setDisabledButton] = useState(true);

    const onSubmit = (dataForm) => {
        if (dataForm) {
            if (disabledButton === false) {
                resetSignalerArmeData(watch('erreurArme'));
            }
            etapeSuivante();
        }
    };

    if (disabledButton && signalerArmeData.typeErreur) {
        setValue('erreurArme', signalerArmeData.typeErreur);
        setDisabledButton(false);
    }

    const handleOnChange = () => {
        setDisabledButton(false);
    };

    return (
        <Container margeExterne={false}>
            <form onSubmit={handleSubmit(onSubmit)} onChange={handleOnChange}>
                <Fieldset
                    id="selectionErreur"
                    legende="Veuillez sélectionner le type d'erreur"
                    alignementHorizontal
                    legendeEnGras
                >
                    <BoutonRadio
                        type="radio"
                        name="erreurArme"
                        label="Je ne possède pas ou je ne possède plus cette arme"
                        value="non-possession"
                        {...register('erreurArme')}
                        disabled={isLoading}
                        onChange={handleOnChange}
                    />
                    <BoutonRadio
                        type="radio"
                        name="erreurArme"
                        label="Les informations de mon arme sont incorrectes"
                        value="information-incorrectes"
                        {...register('erreurArme')}
                        disabled={isLoading}
                        onChange={handleOnChange}
                    />
                </Fieldset>
                <BoutonEtape
                    nameBtnSuivant="etapeSuivante"
                    labelBtnSuivant="Étape suivante"
                    labelBtnPrecedent="Annuler"
                    actionPrecedente={() => {
                        history.push(getPath(RoutesRatelier));
                    }}
                    btnSuivantDisabled={disabledButton}
                />
            </form>
        </Container>
    );
};

SignalerErreurEtape1.propTypes = {
    etapeSuivante: PropTypes.bool.isRequired,
    resetSignalerArmeData: PropTypes.func.isRequired,
    signalerArmeData: PropTypes.shape({
        uuidArme: PropTypes.string.isRequired,
        typeErreur: PropTypes.string,
    }).isRequired,
};

export default SignalerErreurEtape1;
